<script>
export default {
  props: {
    qty: Number,
    white: [Boolean, String],
  },
};
</script>

<template lang='pug'>
.relative(v-show='qty || white', :class='white ? "inline align-middle" : null')
  svg.cursor-pointer(
    xmlns='http://www.w3.org/2000/svg',
    width='22',
    height='18',
    viewBox='0 0 22 18',
    :tabindex='white ? null : 0',
    :class='white ? "inline" : null',
    @click='$emit("click", $event)',
  )
    path.fill-current(
      :class='white ? "text-white" : "text-brand"',
      d='M21.854 2.863a.827.827 0 0 0-.685-.368H6.74L4.868.375A1.098 1.098 0 0 0 \
        4.044 0H1.108C.496 0 0 .506 0 1.13c0 .623.496 1.129 1.108 1.129H3.55l1.51 1.712 \
        3.202 8.486a.831.831 0 0 0 .775.543h8.808a.831.831 0 0 0 .775-.543l3.324-8.81a.861.861 0 0 0-.09-.784z',
    )
    path.fill-current(
      :class='white ? "text-white" : "text-brand"',
      d='M10 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4z',
    )
    path.fill-current(
      :class='white ? "text-white" : "text-brand"',
      d='M17 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4z',
    )
  .qty.absolute.text-brand.bg-white.border.border-brand.text-center(v-if='qty') {{qty}}
</template>

<style>
@import '~import/index';

.qty {
  padding: 0 2px;
  top: -50%;
  right: -50%;
  font-size: 12px;
  line-height: 14px;
  border-radius: 9999px;
  height: 16px;
  min-width: 16px;
}
</style>